export default "__VITE_ASSET__BpzAbiHH__"